import { PrinterOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Badge, Button, Tooltip } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { printJobStats } from '@/services/printJobs';

const PrintAlertBadge: React.FC = () => {
  const [alertCount, setAlertCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const response = await printJobStats();
      if (response.code === 0) {
        setAlertCount(Number(response.data?.alert_count || 0));
      }
    } catch (_error) {
      // 顶栏提醒不能打断后台其他操作，详情页会展示明确错误。
    }
  }, []);

  useEffect(() => {
    void refresh();
    const timer = window.setInterval(() => void refresh(), 30_000);
    return () => window.clearInterval(timer);
  }, [refresh]);

  return (
    <Tooltip
      title={alertCount > 0 ? `${alertCount} 个打印异常待处理` : '打印任务中心'}
    >
      <Badge count={alertCount} size="small" overflowCount={99}>
        <Button
          type="text"
          icon={<PrinterOutlined />}
          aria-label="打印任务中心"
          onClick={() => history.push('/orders/print-jobs')}
        />
      </Badge>
    </Tooltip>
  );
};

export default PrintAlertBadge;
